var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.template)?_c('div',{staticClass:"in-app-card"},[_c('InAppPreviewLayout',{scopedSlots:_vm._u([{key:"vertical",fn:function(){return [_c('div',{staticClass:"in-app-card-vertical",style:({
                    backgroundColor: _vm.template.InAppProps.Styling.MessageBackgroundColor
                })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.InAppProps.Image.AfterTitle && _vm.title),expression:"template.InAppProps.Image.AfterTitle && title"}],staticClass:"in-app-card-title in-app-card-vertical__title",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Title.Color,
                            height:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            lineHeight:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            textAlign: _vm.template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                        })},[_vm._v("\n                  "+_vm._s(_vm.template.Title || _vm.template.Subject)+"\n                ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                        _vm.template.InAppProps.Image.URL &&
                        _vm.template.InAppProps.Image.URL.length
                    ),expression:"\n                        template.InAppProps.Image.URL &&\n                        template.InAppProps.Image.URL.length\n                    "}],staticClass:"in-app-card-vertical__banner",style:({
                        backgroundImage: ("url(" + (_vm.template.InAppProps.Image.URL) + ")"),
                        paddingTop: ((100 / _vm.numericalSideRatio) + "%")
                    }),on:{"click":function($event){return _vm.onOpenUrl(_vm.template.InAppProps.Image.ActionURL)}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVerticalBody),expression:"showVerticalBody"}],staticClass:"in-app-card-vertical-body"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title && !_vm.template.InAppProps.Image.AfterTitle),expression:"title && !template.InAppProps.Image.AfterTitle"}],staticClass:"in-app-card-title in-app-card-vertical-body__title",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Title.Color,
                            height:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            lineHeight:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            textAlign: _vm.template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                        })},[_vm._v(_vm._s(_vm.template.Title || _vm.template.Subject))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.Template),expression:"template.Template"}],staticClass:"in-app-card-vertical-body__text",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Desc.FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Desc.Color,
                            height:
                                (+_vm.template.InAppProps.Styling.Desc
                                    .FontSize +
                                    1) *
                                    _vm.textSmallingCoef *
                                    2 +
                                'px',
                            lineHeight:
                                +(
                                    _vm.template.InAppProps.Styling.Desc
                                        .FontSize + 1
                                ) *
                                    _vm.textSmallingCoef +
                                'px',
                            textAlign: _vm.template.InAppProps.Styling.Desc.AlignLeft ? 'left': 'center'
                        })},[_vm._v(_vm._s(_vm.template.Template))]),_c('div',{staticClass:"in-app-card-vertical-body-buttons"},[_c('div',{staticClass:"in-app-card-vertical-body-buttons__wrapper"},[(
                                    _vm.template.InAppProps.SecondaryButton
                                        .Title
                                )?_c('span',{staticClass:"in-app-card__button in-app-card-vertical-body__button",style:({
                                    color:
                                        _vm.template.InAppProps.Styling
                                            .SecondaryButtonColor,
                                    backgroundColor: _vm.template.InAppProps.SecondaryButton.BackgroundColor,
                                    borderColor: _vm.template.InAppProps.SecondaryButton.BordersColor,
                                    borderStyle: _vm.template.InAppProps.SecondaryButton.Title ? 'solid' : 'hidden'
                                }),on:{"click":function($event){return _vm.onOpenUrl(
                                        _vm.template.InAppProps.SecondaryButton
                                            .ActionURL
                                    )}}},[_vm._v(_vm._s(_vm.template.InAppProps.SecondaryButton
                                        .Title))]):_vm._e(),(
                                    _vm.template.InAppProps.PrimaryButton.Title
                                )?_c('span',{staticClass:"in-app-card__button in-app-card-vertical-body__button",style:({
                                    color:
                                        _vm.template.InAppProps.Styling
                                            .PrimaryButtonColor,
                                    backgroundColor: _vm.template.InAppProps.PrimaryButton.BackgroundColor,
                                    borderColor: _vm.template.InAppProps.PrimaryButton.BordersColor,
                                    borderStyle: _vm.template.InAppProps.PrimaryButton.Title ? 'solid' : 'hidden'
                                }),on:{"click":function($event){return _vm.onOpenUrl(
                                        _vm.template.InAppProps.PrimaryButton
                                            .ActionURL
                                    )}}},[_vm._v(_vm._s(_vm.template.InAppProps.PrimaryButton.Title))]):_vm._e()])])])])]},proxy:true},{key:"horizontal",fn:function(){return [_c('div',{staticClass:"in-app-card-horizontal",style:({
                    display:
                        _vm.template.InAppProps.Image.LandscapeURL &&
                        _vm.template.InAppProps.Image.LandscapeURL.length
                            ? null
                            : 'block',
                    backgroundColor: _vm.template.InAppProps.Styling.MessageBackgroundColor
                })},[(
                        _vm.template.InAppProps.Image.LandscapeURL &&
                        _vm.template.InAppProps.Image.LandscapeURL.length
                    )?_c('div',{staticClass:"in-app-card-horizontal__banner",style:({
                        backgroundImage: ("url(" + (_vm.template.InAppProps.Image.LandscapeURL) + ")"),
                    }),on:{"click":function($event){return _vm.onOpenUrl(_vm.template.InAppProps.Image.ActionURL)}}}):_vm._e(),_c('div',{staticClass:"in-app-card-horizontal-body"},[_c('span',{staticClass:"in-app-card-title in-app-card-horizontal-body__title",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Title.Color,
                            height:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            lineHeight:
                                +_vm.template.InAppProps.Styling.Title
                                    .FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            textAlign: _vm.template.InAppProps.Styling.Title.AlignLeft ? 'left': 'center'
                        })},[_vm._v(_vm._s(_vm.template.Title || _vm.template.Subject))]),_c('span',{staticClass:"in-app-card-horizontal-body__text",style:({
                            fontSize:
                                +_vm.template.InAppProps.Styling.Desc.FontSize *
                                    _vm.textSmallingCoef +
                                'px',
                            color: _vm.template.InAppProps.Styling.Desc.Color,
                            height:
                                (+_vm.template.InAppProps.Styling.Desc
                                    .FontSize +
                                    1) *
                                    _vm.textSmallingCoef *
                                    3 +
                                'px',
                            lineHeight:
                                +(
                                    _vm.template.InAppProps.Styling.Desc
                                        .FontSize + 1
                                ) *
                                    _vm.textSmallingCoef +
                                'px',
                            textAlign: _vm.template.InAppProps.Styling.Desc.AlignLeft ? 'left': 'center'
                        })},[_vm._v(_vm._s(_vm.template.Template))]),_c('div',{staticClass:"in-app-card-horizontal-body-buttons"},[_c('div',{staticClass:"in-app-card-horizontal-body-buttons__wrapper"},[(
                                    _vm.template.InAppProps.SecondaryButton
                                        .Title
                                )?_c('span',{staticClass:"in-app-card__button in-app-card-horizontal-body__button",style:({
                                    color:
                                        _vm.template.InAppProps.Styling
                                            .SecondaryButtonColor,
                                    backgroundColor: _vm.template.InAppProps.SecondaryButton.BackgroundColor,
                                    borderColor: _vm.template.InAppProps.SecondaryButton.BordersColor,
                                    borderStyle: _vm.template.InAppProps.SecondaryButton.Title ? 'solid' : 'hidden'
                                }),on:{"click":function($event){return _vm.onOpenUrl(
                                        _vm.template.InAppProps.SecondaryButton
                                            .ActionURL
                                    )}}},[_vm._v(_vm._s(_vm.template.InAppProps.SecondaryButton
                                        .Title))]):_vm._e(),(
                                    _vm.template.InAppProps.PrimaryButton.Title
                                )?_c('span',{staticClass:"in-app-card__button in-app-card-horizontal-body__button",style:({
                                    color:
                                        _vm.template.InAppProps.Styling
                                            .PrimaryButtonColor,
                                    backgroundColor: _vm.template.InAppProps.PrimaryButton.BackgroundColor,
                                    borderColor: _vm.template.InAppProps.PrimaryButton.BordersColor,
                                    borderStyle: _vm.template.InAppProps.PrimaryButton.Title ? 'solid' : 'hidden'
                                }),on:{"click":function($event){return _vm.onOpenUrl(
                                        _vm.template.InAppProps.PrimaryButton
                                            .ActionURL
                                    )}}},[_vm._v(_vm._s(_vm.template.InAppProps.PrimaryButton.Title))]):_vm._e()])])])])]},proxy:true}],null,false,574608840)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }